// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Dl18","inputWrap":"styles_inputWrap__p_TE8","input":"styles_input__23qUX"};